import { render, staticRenderFns } from "./EditSubsidiaries.vue?vue&type=template&id=251fde58&"
import script from "./EditSubsidiaries.vue?vue&type=script&lang=js&"
export * from "./EditSubsidiaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports